import type { WixRicosViewerProps } from '@wix/ricos';
import { WixRicosViewer } from '@wix/ricos';
import type { FunctionComponent } from 'react';
import React from 'react';
import '@wix/ricos/css/ricos-viewer.global.css';
import { getSelectedPlugins } from '../../../services/viewer-plugins';

const linkSettings = {
  anchorTarget: '_blank',
  relValue: 'noreferrer',
};

const Viewer: FunctionComponent<
  WixRicosViewerProps & {
    isInSEO?: boolean;
    useLinkToSection?: boolean;
    useVerticalSlimLayout?: boolean;
    clickToTweet?: boolean;
    selectedPlugins: Record<string, boolean>;
  }
> = ({
  locale,
  theme,
  instance,
  isMobile,
  content,
  isInSEO,
  useLinkToSection,
  useVerticalSlimLayout,
  clickToTweet,
  selectedPlugins,
  mediaSettings,
  wixExperiments,
  biSettings,
}) => {
  const commonProps: WixRicosViewerProps = {
    locale,
    plugins:
      selectedPlugins &&
      getSelectedPlugins(selectedPlugins, {
        useLinkToSection,
        useVerticalSlimLayout,
      }),
    biSettings,
    theme,
    instance,
    isMobile,
    content,
    seoSettings: isInSEO,
    linkSettings,
    mediaSettings,
    wixExperiments,
    textSelectionToolbar: clickToTweet,
  };

  return <WixRicosViewer {...commonProps} />;
};
export default Viewer;
